import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToast } from "@vertesia/ui/core";
import { useUserSession } from "@vertesia/ui/session";
import { useCallback, useState } from "react";
import { useUITranslation } from '../../../../../i18n/index.js';
import { i18nInstance, NAMESPACE } from '../../../../../i18n/instance.js';
import { SelectContentTypeModal } from "../../../types";
import { useObjectsActionCallback } from "../ObjectsActionHooks";
export function ChangeTypeActionComponent({ action, objectIds, children }) {
    const { t } = useUITranslation();
    const { store } = useUserSession();
    const toast = useToast();
    const [isOpen, setOpen] = useState(false);
    const callback = useCallback(() => {
        setOpen(true);
        return Promise.resolve(true);
    }, []);
    useObjectsActionCallback(action.id, callback);
    const handleTypeSelect = (typeId) => {
        // Close the modal
        setOpen(false);
        // If no selection was made
        if (typeId === undefined) {
            return;
        }
        // Execute the operation with the selected typeId
        store.runOperation({
            name: "change_type",
            ids: objectIds,
            params: { typeId }
        }).then((r) => {
            toast({
                status: 'success',
                title: t('store.actions.changeType'),
                description: `Change the type of ${objectIds.length} objects is ${r.status === 'in_progress' ? 'in progress' : 'completed'}`,
                duration: 2000
            });
        }).catch(err => {
            toast({
                status: 'error',
                title: t('store.actions.errorChangingType'),
                description: err.message,
                duration: 5000
            });
        });
    };
    return (_jsxs("div", { children: [children, _jsx(SelectContentTypeModal, { isOpen: isOpen, onClose: handleTypeSelect, title: "Change Content Type", confirmLabel: "Change Type", children: _jsxs("p", { className: "pt-2 text-xs", children: ["Note: This action will raise the ", _jsx("code", { children: "change_type" }), " event and will trigger the standard intake workflows which may reset the object properties."] }) })] }));
}
const t = i18nInstance.getFixedT(null, NAMESPACE);
export const ChangeTypeAction = {
    id: "changeType",
    name: t('store.actions.changeContentType'),
    description: t('store.actions.changeContentTypeDesc'),
    confirm: false,
    component: ChangeTypeActionComponent,
};
//# sourceMappingURL=ChangeTypeAction.js.map